import { Directive, ElementRef, forwardRef, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormatter]',
   providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyFormatterDirective),
      multi: true
    }
  ]
})
export class CurrencyFormatterDirective implements OnInit, OnChanges {


  @Input() symbol ;
  @Input() value: any;

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.writeValue(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].isFirstChange) {
      this.writeValue(changes['value'].currentValue);
    }
  }


  @HostListener('focus')
  onFocus(): void {
    const value = this.el.nativeElement.value;
    this.el.nativeElement.value = value.replace(/[^0-9.]/g, '');
  }

  @HostListener('blur')
  onBlur(): void {
    const value = this.el.nativeElement.value.trim();

    if (!value) {
      this.onChange(null);
      return;
    }

    const numericValue = parseFloat(value.replace(/[^0-9.]/g, ''));
    if (!isNaN(numericValue)) {
      this.onChange(numericValue);
      this.el.nativeElement.value = this.formatValue(numericValue);
    }
  }

  writeValue(value: any): void {
    if (value !== null && value !== undefined && !isNaN(value)) {
      this.el.nativeElement.value = this.formatValue(parseFloat(value));
    } else {
      this.el.nativeElement.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = (value: any) => {
      fn(value);
      this.writeValue(value);
    };
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  private formatValue(value: number): string {
    const formatted = value
      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return this.symbol ? `${this.symbol} ${formatted}` : formatted;
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/CurrencyFormatter/currency-formatter.directive.ts